import { Input, Select, SelectOptionType, TextArea } from "@aidkitorg/component-library";
import React, { useCallback, useMemo } from "react";
import { useLocalizedStrings } from "../../../Localization";
import { useFieldOptions } from "../../hooks/useFieldOptions";

export type MapFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,
    
  geographicDataOption: string,
  setGeographicDataOption: (val: string) => void,

  addressField: string,
  setAddressField: (val: string) => void,

  geoJSONUrl: string,
  setGeoJSONUrl: (val: string) => void,
}

export const MapFormFields: React.FC<MapFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  geographicDataOption, setGeographicDataOption,
  addressField, setAddressField,
  geoJSONUrl, setGeoJSONUrl
}) => {
  const L = useLocalizedStrings()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions({
    componentKinds: ['Address']
  })

  const MAP_GEOGRAPHIC_DATA_OPTIONS: Array<SelectOptionType> = useMemo(() => [
    {value: 'point', label: L.admin_panel.dashboards.points},
    {value: 'polygons', label: L.admin_panel.dashboards.polygons}
  ], [])

  const getMapGeographicDataOption = useCallback((value: string) => {
    return MAP_GEOGRAPHIC_DATA_OPTIONS.find((v) => v.value === value)
  }, [])

  return <>
    <Input 
      required
      label={L.admin_panel.dashboards.map_title}
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />
  
    <Select 
      portal
      virtualized
      options={MAP_GEOGRAPHIC_DATA_OPTIONS}
      label={L.admin_panel.dashboards.geo_data_type}
      description={L.admin_panel.dashboards.geo_data_desc}
      labelLocation="above"
      value={getMapGeographicDataOption(geographicDataOption)}
      onChange={(value) => { 
        setGeographicDataOption(value.value)}}
    />
  
    {geographicDataOption === 'point' && (
      <Select
        portal
        options={fieldOptions}
        label={L.admin_panel.dashboards.address_field}
        description="Select the field containing address data for mapping"
        labelLocation="above"
        value={getSelectedFieldOption(addressField)}
        onChange={(value) => {
          if (value) setAddressField(value.value)
        }}
        placeholder="Choose an address field..."
        searchable
      />
    )}
    {geographicDataOption === 'polygons' && (
      <Input 
        required
        label={L.admin_panel.dashboards.geojson_import}
        value={geoJSONUrl}
        onChange={(e) => setGeoJSONUrl(e.target.value)}
      />
    )}
  
    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}